exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntr.checked[data-v-62f208b8], tr.checked[data-v-62f208b8]:hover {\n    background-color: #0094ff !important;\n    color: #fff;\n}\ntable.small-padding td[data-v-62f208b8], table.small-padding th[data-v-62f208b8]{\n    padding: 3px 5px;\n}\n", ""]);

// exports
